// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageNavigation_wrapper__1gWQf","button":"PageNavigation_button__1pBhS","chevron":"PageNavigation_chevron__1gDTc","image":"PageNavigation_image__K66EH"};